import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { colorBlack, colorWhite, headerStyle, headerStyleContrast, subHeaderStyle, subHeaderStyleContrast } from "../../helper/style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const LiqueAccordion = ({ title, children, defaultExpanded = false, theme = "default", largeTitle = false }) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{ background: "transparent", boxShadow: "none", '& .MuiAccordionSummary-content': { marginTop: 0 } }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={theme === "default" ? { ...colorWhite } : {...colorBlack}} />}
        aria-controls="panel-detail-content"
        id="panel-detail-header"
        sx={{ paddingBottom: "5px" }}
      >
        {
          largeTitle ? (
            <Typography variant="h4" sx={theme === "default" ? { ...headerStyle } : { ...headerStyleContrast }}>
              {title}
            </Typography>
          ) : (
            <Typography variant="h4" sx={theme === "default" ? { ...subHeaderStyle } : { ...subHeaderStyleContrast }}>
              {title}
            </Typography>
          )
        }
      </AccordionSummary>
      <AccordionDetails sx={{ paddingY: "5px", paddingX: "20px" }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default LiqueAccordion;
